<template>
    <div class="content-body">
        <div class="content-inside">
            <template v-if="form.user.role === 'user'">
                <b-form v-show="loading === false">
                    <b-row class="mt-3">
                        <b-col sm="12" md="7">
                            <b-row>
                                <b-col cols="8">
                                    <b-form-group
                                        label="First Name"
                                        label-for="userFirstName"
                                        class="sl-helper"
                                        :invalid-feedback="errorMessage('firstname')"
                                        :state="isValid('firstname')">
                                        <b-form-input
                                            id="userFirstName"
                                            type="text"
                                            placeholder=""
                                            v-model="form.user.firstName">
                                        </b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                        label="Last Name"
                                        label-for="userLastName"
                                        class="sl-helper"
                                        :invalid-feedback="errorMessage('lastname')"
                                        :state="isValid('lastname')">
                                        <b-form-input
                                            id="userLastName"
                                            type="text"
                                            placeholder=""
                                            v-model="form.user.lastName">
                                        </b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                        label="Email"
                                        label-for="userEmail"
                                        class="sl-helper">
                                        <b-form-input
                                            id="userEmail"
                                            type="email"
                                            placeholder=""
                                            readonly
                                            disabled
                                            v-model="form.user.email">
                                        </b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                        label="Mobile No."
                                        label-for="userMobileNumber"
                                        class="sl-helper"
                                        :invalid-feedback="errorMessage('mobile')"
                                        :state="isValid('mobile')">
                                        <b-form-input
                                            id="userMobileNumber"
                                            type="text"
                                            placeholder=""
                                            minlength="11"
                                            maxlength="11"
                                            v-model="form.user.mobileNumber"
                                            @keypress.native="isNumber"></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-button
                                        size="lg"
                                        variant="primary"
                                        class="save-button mt-4 px-5"
                                        @click="updateUserProfile">
                                        Update
                                    </b-button>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-form>
            </template>
            <template v-else>
                <b-form v-show="loading === false && form.user.role === 'admin'">
                    <b-row class="mt-3">
                        <b-col sm="12" md="2"><h6 class="align-middle">Company</h6></b-col>
                        <b-col sm="12" md="7">
                            <b-row>
                                <b-col cols="8">
                                    <b-form-group
                                        label="Company Name"
                                        label-for="companyName"
                                        class="sl-helper"
                                        :invalid-feedback="errorMessage('name')"
                                        :state="isValid('name')"
                                        >
                                        <b-form-input
                                            id="companyName"
                                            type="text"
                                            placeholder=""
                                            v-model="form.companyName">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="4">
                                    <b-form-group
                                        label="Registration No."
                                        label-for="registrationNumber"
                                        class="sl-helper"
                                        :invalid-feedback="errorMessage('registration_number')"
                                        :state="isValid('registration_number')"
                                        >
                                        <b-form-input
                                            id="registrationNumber"
                                            type="text"
                                            placeholder=""
                                            v-model="form.registrationNumber">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="4">
                                    <b-form-group
                                        label="TIN No."
                                        label-for="tinNumber"
                                        class="sl-helper"
                                        :invalid-feedback="errorMessage('tin_number')"
                                        :state="isValid('tin_number')"
                                        >
                                        <b-form-input
                                            id="tinNumber"
                                            type="text"
                                            placeholder=""
                                            v-model="form.tinNumber">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="9"><hr></b-col>
                        <b-col></b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col sm="12" md="2"><h6 class="align-middle">Representative</h6></b-col>
                        <b-col sm="12" md="7">
                            <b-row class="d-none">
                                <b-col sm="4" md="2">
                                    <b-form-group id="fieldsetHorizontal" class="user-badge">

                                        <label for="userImage" v-b-modal.uploadProfileImage>
                                            <img v-if="form.user.image === '' && form.user.image === null" src="@/assets/images/defaultavatar.svg" alt="Sample Badge" class="default-img">
                                            <img v-else :src="form.user.image" alt="Sample Badge" class="default-img">
                                                <img src="@/assets/images/camera.svg" alt="" class="default-img camera">
                                        </label>
                                    </b-form-group>
                                    <b-modal id="uploadProfileImage" ref="uploadImageModalRef" title="Upload Image">
                                        <div id="profile-image-upload-container" class="border mx-auto">
                                            <croppa
                                                v-model="croppa"
                                                @new-image-drawn="onNewImage"
                                                @zoom="onZoom"
                                                :width="200"
                                                :height="200"
                                                placeholder="Choose an Image"
                                                :show-remove-button="true"
                                                :placeholder-font-size="14"
                                                remove-button-color="#ff8828">
                                            </croppa>
                                        </div>
                                        <div id="profile-image-range-container" class="mx-auto mt-2">
                                            <input type="range" class="custom-range" id="customRange1" @input="onSliderChange" :min="sliderMin" :max="sliderMax" step=".001" v-model="sliderVal">
                                        </div>
                                        <div slot="modal-footer">
                                            <b-button variant="ghost" class="btn-cancel" @click="hideUploadImageModal(true)" style="margin-right: .25rem;">
                                                Cancel
                                            </b-button>
                                            <b-button variant="primary" @click="hideUploadImageModal(false)" style="margin-left: .25rem;">
                                                Save
                                            </b-button>
                                        </div>
                                    </b-modal>
                                </b-col>
                                <b-col cols="4" class="mt-3" sm="4" md="3">
                                    <h6>Profile Image</h6>
                                    <h6 class="sub-title">(200 x 200)</h6>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="4">
                                    <b-form-group label="First Name" label-for="firstName" class="sl-helper"
                                        :invalid-feedback="errorMessage('firstname')"
                                        :state="isValid('firstname')">
                                        <b-form-input
                                            id="firstName"
                                            type="text"
                                            placeholder=""
                                            v-model="form.user.firstName"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="4">
                                    <b-form-group label="Last Name" label-for="lastName" class="sl-helper"
                                        :invalid-feedback="errorMessage('lastname')"
                                        :state="isValid('lastname')">
                                        <b-form-input
                                            id="lastName"
                                            type="text"
                                            placeholder=""
                                            v-model="form.user.lastName"></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="4">
                                    <b-form-group label="ID No." label-for="idNumber" class="sl-helper"
                                        :invalid-feedback="errorMessage('id_number')"
                                        :state="isValid('id_number')">
                                        <b-form-input
                                            id="idNumber"
                                            type="text"
                                            placeholder=""
                                            v-model="form.user.idNumber"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="4">
                                    <b-form-group label="Designation" label-for="designation" class="sl-helper"
                                        :invalid-feedback="errorMessage('designation')"
                                        :state="isValid('designation')">
                                        <b-form-input
                                            id="designation"
                                            type="text"
                                            placeholder=""
                                            v-model="form.user.designation"></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="4">
                                    <b-form-group label="Email" label-for="email" class="sl-helper"
                                        :invalid-feedback="errorMessage('email')"
                                        :state="isValid('email')"
                                        >
                                        <b-form-input
                                            id="email"
                                            type="email"
                                            placeholder=""
                                            v-model="form.user.email"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="4">
                                    <b-form-group label="Mobile No." label-for="mobileNumber" class="sl-helper"
                                        :invalid-feedback="errorMessage('mobile')"
                                        :state="isValid('mobile')">
                                        <b-form-input
                                            id="mobileNumber"
                                            type="text"
                                            placeholder=""
                                            maxlength="11"
                                            v-model="form.user.mobileNumber"
                                            @keypress.native="isNumber"></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="9"><hr></b-col>
                        <b-col></b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col sm="12" md="2"><h6 class="align-middle">Billing</h6></b-col>
                        <b-col sm="12" md="7">
                            <b-row>
                                <b-col cols="4">
                                    <b-form-group label="Email" 
                                        label-for="billingEmail" 
                                        class="sl-helper"
                                        :invalid-feedback="errorMessage('billing_email')"
                                        :state="isValid('billing_email')"
                                        >
                                        <b-form-input
                                            id="billingEmail"
                                            type="text"
                                            placeholder=""
                                            v-model="form.billingEmail">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="6">
                                    <b-form-group label="Billing Address" 
                                        label-for="billingAddress" 
                                        class="sl-helper"
                                        :invalid-feedback="errorMessage('billing_address')"
                                        :state="isValid('billing_address')"
                                        >
                                        <b-form-textarea
                                            id="billingAddress"
                                            placeholder="Enter address"
                                            :rows="3"
                                            :max-rows="6"
                                            v-model="form.billingAddress"></b-form-textarea>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="9"><hr></b-col>
                        <b-col></b-col>
                    </b-row>
                    <b-row>
                        <b-col><b-button size="lg" variant="primary" class="save-button mt-4 px-5" @click="updateProfile" :block="true" >Update</b-button></b-col>

                        <b-col cols="10"></b-col>
                    </b-row>
                </b-form>
            </template>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { mapGetters } from "vuex";

export default {
    name: "profile",
    props: ["profile"],
    components: {},

    data() {
        return {
            form: {
                companyName: null,
                registrationNumber: null,
                tinNumber: null,
                billingEmail: null,
                billingAddress: null,
                user: {
                    firstname: null,
                    lastname: null,
                    designation: null,
                    email: null,
                    logo_image: null,
                    image: null,
                    uuid: null,
                    role: null,
                    mobile: null
                }
            },

            croppa: {},
            sliderVal: 0,
            sliderMin: 0,
            sliderMax: 0
        };
    },
    computed: {
        ...mapGetters("accountProfile", [
            "getUser",
            "getUpdatedProfile",
            "getUpdatedUserProfile"
        ]),
        ...mapState("accountProfile", ["detail", "loading", "errors"]),
        isSuspended: {
            get() {
                return this.detail.contract_status === 'suspended';
            },
            set(status) {
                return status;
            }
        }
    },

    created() {
        this.setLoading(true);
        this.getDetail();
    },

    methods: {
        onNewImage() {
            this.sliderVal = this.croppa.scaleRatio;
            this.sliderMin = this.croppa.scaleRatio / 2;
            this.sliderMax = this.croppa.scaleRatio * 2;
        },
        onSliderChange(evt) {
            var increment = evt.target.value;
            this.croppa.scaleRatio = +increment;
        },
        onZoom() {
            this.sliderVal = this.croppa.scaleRatio;
        },

        hideUploadImageModal(forceClose = false) {
            if (forceClose) {
                this.form.image = null;
                this.$refs.uploadImageModalRef.hide();

                return false;
            }

            var image = this.croppa.generateDataUrl();

            if (image === "") {
                return false;
            }

            this.form.user.image = image;
            this.$refs.uploadImageModalRef.hide();
            return true;
        },

        async getDetail() {
            let _this = this;

            await this.$store
                .dispatch("accountProfile/assignMerchantDetail")
                .then(function() {
                    _this.form.companyName = _this.detail.name;
                    _this.form.registrationNumber =
                        _this.detail.registration_number;
                    _this.form.tinNumber = _this.detail.tin_number;

                    _this.form.billingEmail = _this.detail.billing_email;
                    _this.form.billingAddress = _this.detail.billing_address;
                    _this.setLoading(false);

                    if (_this.isSuspended) _this.$router.push({ name: 'MyPlanDetails' });
                });

            this.$store.dispatch("accountProfile/getUserProfile").then(user => {
                _this.form.user.firstName = user.firstname;
                _this.form.user.lastName = user.lastname;
                _this.form.user.idNumber = user.id_number;
                _this.form.user.designation = user.designation;
                _this.form.user.mobileNumber = user.mobile;
                _this.form.user.email = user.email;
                _this.form.user.image = user.logo_image;
                _this.form.user.uuid = user.uuid;
                _this.form.user.role = user.role;
            });
        },

        updateProfile: async function() {
            let _this = this;

            this.$store.commit("accountProfile/setUserProfile", this.form.user);

            this.$store.commit("accountProfile/setMerchantProfile", this.form);

            this.$store
                .dispatch("accountProfile/updateAdminProfile")
                .then(() => {
                    let user = _this.getUpdatedUserProfile;
                    _this.form.user.firstName = user.firstname;
                    _this.form.user.lastName = user.lastname;
                    _this.form.user.idNumber = user.id_number;
                    _this.form.user.designation = user.designation;
                    _this.form.user.mobileNumber = user.mobile;
                    _this.form.user.email = user.email;
                    _this.form.user.image = user.logo_image;
                    _this.form.user.uuid = user.uuid;

                    let merchant = _this.getUpdatedProfile;
                    _this.form.companyName = merchant.name;
                    _this.form.registrationNumber =
                        merchant.registration_number;
                    _this.form.tinNumber = merchant.tin_number;

                    _this.form.billingEmail = _this.detail.billing_email;
                    _this.form.billingAddress = _this.detail.billing_address;
                });

            this.setLoading(false);
        },

        async updateUserProfile() {
            let _this = this;

            this.$store.commit("accountProfile/setUser", this.form.user);
            await this.$store.dispatch("accountProfile/updateUser");
        },

        isValid(field) {
            if (this.errors == null) {
                return false;
            }
            return this.errors.errors[field] ? false : true;
        },

        errorMessage(field) {
            if (this.errors == null) {
                return "";
            }
            return this.errors.errors[field];
        },

        async setLoading(value) {
            await this.$store.dispatch("accountProfile/setLoading", value);
        },

        isNumber: function(evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (
                charCode > 31 &&
                (charCode < 48 || charCode > 57) &&
                charCode !== 46
            ) {
                evt.preventDefault();
            } else {
                return true;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
h5 {
    font-size: 16px;
}
h6 {
    font-family: MainFontBold, sans-serif;
    font-size: 16px;
}
</style>
